import * as yup from 'yup'

import { getPhoneNumberValidator } from '@/utils/phoneNumberValidator'

type Kind = 'casavo' | 'agency'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getValidationSchema = (t: (key: string, query?: any) => string, kind: Kind): Record<string, any> => {
  if (kind === 'casavo') {
    return yup.object().shape({
      consentForCasavoMortgageService: yup.boolean(),
      hasAcceptedMarketing: yup.boolean(),
      leadEmail: yup.string().email(t('common:invalid-email-message')).required(t('common:required-field-message')),
      leadMessage: yup.string(),
      leadName: yup.string(),
      leadPhoneNumber: getPhoneNumberValidator(t('common:required-field-message'), t('common:invalid-phone-message')),
      leadPhoneNumberPrefix: yup.string().required(),
      leadReason: yup.string().required(),
    })
  } else {
    return yup.object().shape({
      consentForCasavoMortgageService: yup.boolean(),
      hasAcceptedMarketing: yup.boolean(),
      leadEmail: yup.string().email(t('common:invalid-email-message')).required(t('common:required-field-message')),
      leadMessage: yup.string(),
      leadPhoneNumber: getPhoneNumberValidator(t('common:required-field-message'), t('common:invalid-phone-message')),
      leadPhoneNumberPrefix: yup.string().required(),
    })
  }
}
